
require('slick-carousel');
$('.slider').slick({
    autoplay: true,
    speed: 800,
    lazyLoad: 'progressive',
    // arrows: true,
    dots: true,
      prevArrow: '<div class="slick-nav prev-arrow"><i></i><svg><use xlink:href="#circle"></svg></div>',
      nextArrow: '<div class="slick-nav next-arrow"><i></i><svg><use xlink:href="#circle"></svg></div>',
      responsive: [{
 
        breakpoint: 992,
        settings: {
            arrows: false,
        }
   
      }],
  }).slickAnimation();
  
  


  //logos
  $('.logos-slider').slick({
    autoplay: true,
    speed: 800,
    autoplaySpeed:900,

    lazyLoad: 'progressive',
    // arrows: true,
    dots: false,
    arrows:false,
    slidesToShow:6,
    slidesToScroll:1,
      responsive: [{
 
        breakpoint: 1400,
        settings: {
          slidesToShow:5,
          slidesToScroll:1,
        },
        breakpoint: 992,
        settings: {
          slidesToShow:3,
          slidesToScroll:1,
        }
        ,
        breakpoint: 520,
        settings: {
          slidesToShow:2,
          slidesToScroll:1,
        }
   
      }],
  })
  
  





  
  //.services-slider

  var numSlick = 0;
  $('.slider-items').each( function() {
    let nextarrow= $(this).parents('.slider-w-top-arrows').find('.arrows').find('.next-arrow');
    let prevarrow= $(this).parents('.slider-w-top-arrows').find('.arrows').find('.prev-arrow');


    numSlick++;
    $(this).addClass( 'slider-' + numSlick ).slick({
      autoplay: true,
      speed: 800,
      autoplaySpeed:850,
      lazyLoad: 'progressive',
      prevArrow :  $(prevarrow),
      nextArrow: $(nextarrow),
      dots: false,
      // arrows:false,
      slidesToShow:4,
      slidesToScroll:1,
        responsive: [{
   
          breakpoint: 1400,
          settings: {
            slidesToShow:4,
            slidesToScroll:1,
          },
          breakpoint: 992,
          settings: {
            slidesToShow:3,
            slidesToScroll:1,
            dots: true,
            arrows:false,
          }
          ,
          breakpoint: 520,
          settings: {
            slidesToShow:2,
            slidesToScroll:1,
            dots: true,
            arrows:false,
          }
     
        }],
    });
  });
  

  // $('.services-slider').slick({


  // })
  
  
  
  $('.slick-nav').on('click touch', function(e) {
    e.preventDefault();

    var arrow = $(this);

    if(!arrow.hasClass('animate')) {
        arrow.addClass('animate');
        setTimeout(() => {
            arrow.removeClass('animate');
        }, 1600);
    }

});




var numSlick = 1;
  $('.slider-more-items').each( function() {
    let nextarrow= $(this).parents('.slider-w-top-arrows').find('.arrows').find('.next-arrow');
    let prevarrow= $(this).parents('.slider-w-top-arrows').find('.arrows').find('.prev-arrow');


    numSlick++;
    $(this).addClass( 'slider-' + numSlick ).slick({
      autoplay: false,
      speed: 800,
      variableWidth: true,

      autoplaySpeed:850,
      lazyLoad: 'progressive',
      arrows:true,

      prevArrow :  $(prevarrow),
      nextArrow: $(nextarrow),
      dots: false,
      // arrows:false,
      slidesToShow:4,
      slidesToScroll:1,
        responsive: [{
   
          breakpoint: 1400,
          settings: {
            slidesToShow:4,
            slidesToScroll:1,
          },
          breakpoint: 992,
          settings: {
            slidesToShow:3,
            slidesToScroll:1,
            dots: true,
            arrows:false,
          }
          ,
          breakpoint: 520,
          settings: {
            slidesToShow:2,
            slidesToScroll:1,
            variableWidth: false,
            autoplay: false,

            dots: true,
            arrows:false,
          }
     
        }],
    });
  });



  ///TESTMONILS
  var num2Slick = 1;
  $('.sliderTopArrows').each( function() {
    let nextarrow= $(this).parents('.slider-w-top-arrows').find('.arrows').find('.next-arrow');
    let prevarrow= $(this).parents('.slider-w-top-arrows').find('.arrows').find('.prev-arrow');


    num2Slick++;
    $(this).addClass( 'slider-' + num2Slick ).slick({
      autoplay: false,
      speed: 800,

      autoplaySpeed:850,
      lazyLoad: 'progressive',
      arrows:true,

      prevArrow :  $(prevarrow),
      nextArrow: $(nextarrow),
      dots: false,
      // arrows:false,

    });
  });
